/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react"

function OpzioniEvento({ opzioniEvento, titolo, comune, provincia, apriBanner, indirizzo, domanda }) {
    const stringa = useRef(); const stringa2 = useRef()//per OPZIONI EVENTO
    const stile1 = "background-color: gainsboro; padding: 5px; cursor: pointer; border-radius: 5px"
    const stile2 = "background-color: gainsboro; padding: 5px; border-radius: 5px"
    const openAI = async (e) => {
        apriBanner('primoRispostaAI'); domanda(e)
    }
    useEffect(() => {
        if (opzioniEvento) {
            const opzioniEventoArr = opzioniEvento.split(',')
            opzioniEventoArr.forEach(element => {
                switch (element) {
                    case 'artisti': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi gli artisti di strada che ci sarànno presso ${titolo} a ${comune} (${provincia})`))
                        para.innerText = "▪ Artisti di strada "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "talenti e spettacoli lungo le strade"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'truccabimbi': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.innerText = "▪ Truccabimbi "; para.style = stile2
                        stringa.current.appendChild(para)
                        para2.innerText = "magia colorata"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'parcheggio': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`ci sono parcheggi liberi in ${indirizzo} a ${comune} - ${provincia} ?`))
                        para.innerText = "▪ Parcheggio gratuito "; para.style = stile2
                        stringa.current.appendChild(para)
                        para2.innerText = "zone di sosta libera gratuita"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'navetta': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.innerText = "▪ Navetta "; para.style = stile2
                        stringa.current.appendChild(para)
                        para2.innerText = "servizio trasporto gratuito"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'mercatini': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi i <b>mercatini</b> che ci saranno presso ${titolo} a ${comune} (${provincia})`))
                        para.innerText = "▪ Mercatino artigianale "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "artigianato locale unico e autentico"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'fiera': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi la fiera che ci sarà presso ${titolo} a ${comune} (${provincia})`))
                        para.innerText = "▪ Fiera espositiva "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "vivi l'esperienza autentica"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'standGastronomici': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi gli stand gastronomici che ci saranno presso ${titolo} a ${comune} (${provincia})`))
                        para.innerText = "▪ Stand gastronomici "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "sapori locali autentici da gustare"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'streetFood': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi lo street food che ci sarà presso ${titolo} a ${comune} (${provincia})`))
                        para.innerText = "▪ Street Food "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "il gusto autentico viaggia sulla strada"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'areaTavoli': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.innerText = "▪ Area tavoli "; para.style = stile2
                        stringa.current.appendChild(para)
                        para2.innerText = "area ristoro libera con zona tavoli"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'birraArtigianale': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi il tipi di birra che ci saranno presso ${titolo} a ${comune} (${provincia})`))
                        para.innerText = "▪ Birra artigianale "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "pura birra artigianale da assaporare"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'musica': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi la musica che ci sarà presso ${titolo} a ${comune} (${provincia})`))
                        para.innerText = "▪ Musica live "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "performance musicale dal vivo"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'djSet': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi la musica che ci sarà presso ${titolo} a ${comune} (${provincia})`))
                        para.innerText = "▪ Dj-set "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "musica in console con DJ SET live"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'centroStorico': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi il centro storico di ${comune} (${provincia})`))
                        para.innerText = "▪ Centro storico visitabile "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "scopri le bellezze del centro storico"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'addobbi': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.innerText = "▪ Addobbi scenografici "; para.style = stile2
                        stringa.current.appendChild(para)
                        para2.innerText = "atmosfera magica creata con allestimenti unici"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'attrazioniBambini': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi le attrazioni per bambini che ci saranno presso ${titolo} a ${comune} (${provincia})`))
                        para.innerText = "▪ Attrazioni per bambini "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "divertimento e magia per i più piccoli"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'liscio': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI(`descrivi chi suonerà il liscio presso ${titolo} a ${comune} (${provincia})`))
                        para.innerText = "▪ Ballo liscio "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "ritmo e tradizione scendono in pista"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'gruppo': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.innerText = "▪ Balli di gruppo "; para.style = stile2
                        stringa.current.appendChild(para)
                        para2.innerText = "ritmo e animazione con balli collettivi"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    case 'scuolaDiBallo': {
                        const para = document.createElement("p"); const para2 = document.createElement("p")
                        para.addEventListener('click', () => openAI("ballo dimostrativo"))
                        para.innerText = "▪ Scuola di ballo "; para.style = stile1
                        stringa.current.appendChild(para)
                        para2.innerText = "esibizione dimostrativa di danza live"; para2.style = "padding: 5px"
                        stringa2.current.appendChild(para2)
                        break
                    }
                    default:
                }
            })
        }
    }, [opzioniEvento])
return (<>
    <div className='opzEvt'>
        <div style={{ fontWeight: '600' }} ref={stringa}></div>
        <div ref={stringa2} className='addImg ms-5' style={{ color: 'navy' }}></div>
    </div>
</>
)
}
export default OpzioniEvento